import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import MysteryPacks from "@/pages/MysteryPacks";
import Subscribe from "@/pages/Subscribe";
import LiveStreams from "@/pages/LiveStreams";
import Cart from "@/pages/Cart";
import Account from "@/pages/Account";
import Login, { Register } from "@/pages/Login";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import Admin from "@/pages/Admin";
import About from "@/pages/About";
import PackContents from "@/pages/PackContents";
import Affiliates from "@/pages/Affiliates";
import SellCards from "@/pages/SellCards";
import Merch from "@/pages/Merch";
import SealedWax from "@/pages/SealedWax";
import BigHits from "@/pages/BigHits";
import LiveBanner from "@/components/LiveBanner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <div className="min-h-screen bg-[var(--cl-bg)] text-white noise-overlay flex flex-col">
            <LiveBanner />
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/mystery-packs" element={<MysteryPacks />} />
                <Route path="/subscribe" element={<Subscribe />} />
                <Route path="/live" element={<LiveStreams />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/account" element={<Account />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/admin/*" element={<Admin />} />
                <Route path="/about" element={<About />} />
                <Route path="/pack-contents" element={<PackContents />} />
                <Route path="/affiliates" element={<Affiliates />} />
                <Route path="/sell-cards" element={<SellCards />} />
                <Route path="/merch" element={<Merch />} />
                <Route path="/sealed" element={<SealedWax />} />
                <Route path="/big-hits" element={<BigHits />} />
              </Routes>
            </main>
            <Footer />
            <Toaster theme="dark" position="top-right" richColors />
          </div>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
